import styled from "@emotion/styled";
import { DEFAULT_FONT_FAMILY } from "../../utils/constants/common/fonts";
import { MAIN_COLOR } from "../../utils/constants/common/utils";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";
import { generateSide } from "../../lib/generateSide";
import { IXButtonProps } from "../../utils/interfaces/Elements/Old_XButton.interfaces";

export const Button = styled.button<IXButtonProps>`
  &[data-x-selected="true"] {
    outline: 2px solid ${MAIN_COLOR};
    outline-offset: 2px;
  }

  font-family: ${(props) => props.fontFamily ?? DEFAULT_FONT_FAMILY};

  color: ${(props) => props.color};

  font-size: ${(props) => props.fontSize};

  text-decoration: ${(props) => props.textDecoration};

  font-style: ${(props) => props.fontStyle};

  line-height: ${(props) => props.lineHeight};

  font-family: ${(props) => props.lineHeight};

  font-weight: ${(props) => props.fontWeight};

  text-align: ${(props) => props.textAlign};

  /* initial spacing */
  background-color: ${(props) => props.bgColor};

  border: ${(props) => generateBorder(props.border)};

  border-radius: ${(props) => generateRadius(props.borderRadius)};

  width: ${(props) => props.width};

  height: ${(props) => props.height};

  margin: ${(props) => generateSide("margin", props.margin) ?? 0};

  padding: ${(props) => generateSide("padding", props.padding) ?? 0};

  box-sizing: border-box;
`;
